<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/czO2H/tc-custom/9781035851072.jpg?1720831243096" alt="This image is the cover for the book American Coastguards, UNST & The B.P. Oily Blacks (1978)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">American Coastguards, UNST & The B.P. Oily Blacks (1978)
      </h1>
      <p class="bookDescription body article font2">
        <p>A few stories encountered mainly in the 21st century as a result of working on construction sites. Humour, still having to deal with the good, the bad, and the nasty! 2018 saw the demise of one of the biggest players: Carillion. How many companies went into receivership like my old company? How many others in the 21st century? Was the philosophy Carillion followed replicated by the Post Office? In 2023, in his autumn statement, Chancellor Jeremy Hunt highlighted receiving payment times by the big companies. I can remember those immortal words: ‘spell redundant’, ‘P45, boss’. The American eagles were just laid off! Subcontractors are worth more dead than alive.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dave Husband
      </h2>
      
      <p class="authorDescription body article">Started in the construction industry as an apprentice quantity surveyor in 1965 when he was aged 16, Dave Husband left FIFE in 1971 to work in Liverpool (Merseyside, Cheshire and North Wales). A naive young Scotsman on a huge learning curve teased by magical scousers. When you are hard up and penniless, humour is still a form of escapism. He saw first oil ashore in 1978 at Sullom Voe, Shetland. Shetland was a great experience. A special mention to the American coastguards. Dave worked on contracts all over the United Kingdom. Scotland, England, Wales and Northern Ireland for the next 50 years. Dealt with “good, bad and sometimes the nasty”. He understood the difference between fair and fare!</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?40f7dd86